<template>
  <div class="asset-img-container">
    <img class="asset-image" src="../assets/data.svg" />
    <img class="asset-image" src="../assets/Hacker.svg" />
    <img class="asset-image" src="../assets/Cat.svg" />
    <img class="asset-image" src="../assets/Whale.svg" />
    <img class="asset-image" src="../assets/Pepper.svg" />
    <img class="asset-image" src="../assets/Salt.svg" />
    <img class="asset-image" src="../assets/Player-one.png" />
    <img class="asset-image" src="../assets/Player-two.png" />
    <img class="asset-image" src="../assets/Player-three.png" />
    <img class="asset-image" src="../assets/Player-four.png" />
    <img class="asset-image" src="../assets/Player-five.png" />
    <img class="asset-image" src="../assets/Player-six.png" />
    <img class="asset-image" src="../assets/Tombstone.svg" />
    <img class="asset-image" src="../assets/Ice-Cream.svg" />
  </div>
</template>

<script>
export default {

}
</script>

<style>

.asset-img-container {
  height: 100vh;
  width: 400px;
  margin: 0 auto;
  overflow: auto;
}

.asset-image {
  margin-left: 50px;
  height: 300px;
  width: 300px;
}

</style>